import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';

import HomePage from '../components/pages/HomePage';
import NotFoundPage from '../components/pages/NotFound';
import TopMenu from './TopMenu';
import ProtectedRoute from '../components/ProtectedRoute';
import ManageClients from './ManageClients';
import ManageUsers from './ManageUsers';
import ManageCreditCards from './ManageCreditCards';
import ManageAchBankInfo from './ManageAchBankInfo';
import ManageTerminals from './ManageTerminals';
import AuditPayments from './AuditPayments';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';

toast.configure({
  autoClose: 5000,
  draggable: false,
});

const App = () => (
  <Container fluid className="noPadding">
    <Row noGutters className="topRow">
      <Col>
        <TopMenu />
      </Col>
    </Row>
    <Row noGutters className="bottomRow">
      <Col className="noMargin">
        <Switch>
          <Route path="/" exact component={HomePage} />
          <ProtectedRoute path="/manage/clients" exact component={ManageClients} />
          <ProtectedRoute path="/manage/users" exact component={ManageUsers} />
          <ProtectedRoute path="/manage/terminals" exact component={ManageTerminals} />
          <ProtectedRoute path="/manage/creditCards" exact component={ManageCreditCards} />
          <ProtectedRoute path="/manage/achBankInfo" exact component={ManageAchBankInfo} />
          <ProtectedRoute path="/payments" exact component={AuditPayments} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Col>
    </Row>
  </Container>
);

export default App;
